import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Collapse } from 'antd';

// Header Styles
export const StyledHeader = styled.header`
  background-color: #111113;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1001;
  height: 70px;
  display: flex;
  justify-content: center;
`;

export const HeaderContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
`;

export const LogoContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  img {
    height: 35px;
  }
`;

export const CenterNavLinks = styled.div`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  
  a {
    margin: 0 10px;
    color: white;
    text-decoration: none;
    font-weight: bold;
    
    &:hover {
      color:rgb(255, 255, 255);
    }
  }
`;

export const RightNavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StyledNavLink = styled(Link)`
  font-weight: 600;
  font-size: 16px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.3s ease;

  &.login {
    color: #ffe955;
    background-color: transparent;
    border: 1px solid #ffe955;

    &:hover {
      background-color: rgba(255, 233, 85, 0.1);
    }
  }

  &.signup {
    background-color: #ffe955;
    color: #000000;

    &:hover {
      background-color: #FFC000;
    }
  }
`;

// Footer Styles
export const StyledFooter = styled.footer`
  background-color: #111113;
  display: flex;
  justify-content: center;
  padding: 40px 0 20px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

export const FooterContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  gap: 30px;
  
  @media (max-width: 768px) {
    gap: 20px;
  }
`;

export const FooterLogo = styled.img`
  height: 55px;
  align-self: flex-start;
  
  @media (max-width: 768px) {
    align-self: center;
    height: 50px;
  }
`;

export const DesktopFooter = styled.div`
  display: block;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileFooter = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

export const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 48px;
  justify-items: start;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
  }
  
  @media (max-width: 768px) {
    display: none;
  }
`;

export const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const ColumnTitle = styled.h4`
  color: #ffe955;
  font-size: 1.375rem;
  font-weight: 600;
  margin: 0;
  margin-bottom: 5px;
`;

export const ColumnLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FooterLinks = styled.div`
  display: flex;
  gap: 20px;
  
  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }
  
  @media (max-width: 480px) {
    gap: 10px;
  }
`;

export const FooterIcons = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;

export const StyledLink = styled.a`
  color: rgb(255, 255, 255);
  text-decoration: none;
  font-size: 18px;
  line-height: 1.5;
  transition: color 0.3s ease;
  font-weight: 400;
  display: block;
  margin: 0;
  
  @media (max-width: 480px) {
    font-size: 18px;
  }
  
  &:hover {
    color: #ffe955;
  }
`;

export const StyledIcon = styled.span`
  color: rgb(255, 255, 255);
  font-size: 24px;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  &:hover {
    color: #ffe955;
  }
`;

// Mobile Collapse Styling
export const StyledCollapse = styled(Collapse)`
  .ant-collapse-item {
    border: none !important;
    background: transparent !important;
  }
  .ant-collapse-header {
    color: #ffe955 !important;
    font-weight: 600 !important;
    font-size: 1.375rem !important;
    padding: 12px 0 !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
    display: flex !important;
    align-items: center !important;
  }
  
  .ant-collapse-content {
    background: transparent !important;
    border: none !important;
  }
  .ant-collapse-content-box {
    padding: 16px 0 !important;
  }
  
  .ant-collapse-content-box a {
    padding: 8px 0 !important;
    margin: 0 !important;
    display: block !important;
    font-size: 18px !important;
  }
    .ant-collapse-content-box a:first-child {
    padding-top: 0 !important;
  }
  
  .ant-collapse-content-box a:last-child {
    padding-bottom: 0 !important;
  }
    .ant-collapse-arrow {
    color: #ffe955 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-top: 0 !important;
  }
`;